import * as React from 'react';
import { FSK_SP_URL } from '../../constants/specialProjects/fskSpecialProject';
import { sendFSKTeaserEvent } from '../../utils/analytics/sendFSKTeaserEvent';
import { trackingClickFSKMortgageBanner, trackingShowFSKMortgageBanner } from './tracking';
import * as styles from './styles.css';
import * as logo from './assets/logo.png';

export interface IFSKMortgageBannerProps {
  isOpen?: boolean;
}

export function FSKMortgageBanner({ isOpen }: IFSKMortgageBannerProps) {
  const bannerRef = React.useRef<HTMLAnchorElement>(null);
  const hitUrl = bannerRef.current?.href || '';

  React.useLayoutEffect(() => {
    if (isOpen) {
      trackingShowFSKMortgageBanner();
      sendFSKTeaserEvent({ action: 'show', hitUrl, bannerPlace: 'top_menu_banner' });
    }
  }, [isOpen, hitUrl]);

  const handleBannerClick = React.useCallback(() => {
    trackingClickFSKMortgageBanner();
    sendFSKTeaserEvent({ action: 'click', hitUrl, bannerPlace: 'top_menu_banner' });
  }, [hitUrl]);

  return (
    <a className={styles['container']} href={FSK_SP_URL} onClick={handleBannerClick} ref={bannerRef}>
      <div className={styles['logo']}>
        <img src={logo} alt="ГК ФСК" width={120} height={40} />
      </div>

      <span className={styles['description']}>
        Ипотека 1,99% на весь срок <mark className={styles['promo']}>Только в июне!</mark>
      </span>
    </a>
  );
}
